export default __webpack_public_path__ + "static/media/mini-btn-checkmark.60984bc6.svg";